import { render, staticRenderFns } from "./ModalAtestados.vue?vue&type=template&id=eaf18060&scoped=true"
import script from "./ModalAtestados.vue?vue&type=script&lang=js"
export * from "./ModalAtestados.vue?vue&type=script&lang=js"
import style0 from "./ModalAtestados.vue?vue&type=style&index=0&id=eaf18060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf18060",
  null
  
)

export default component.exports